import { helper } from '@ember/component/helper';
import type { GraphLine, GraphGeometry } from '../index.d.ts';
import { generateFunctionLine, generateFunctionSpurs } from '../utils/graphUtils.ts';
//import { GraphLine, GraphGeometry } from '@ebiz/ember-aditools-graph/..';

export interface FunctionLineSignature {
  Args: {
    Positional: [];
    Named: { line: GraphLine; geometry: GraphGeometry; spur?: boolean };
  };
  Return: string;
}

const functionLine = helper<FunctionLineSignature>((params, { line, geometry, spur }) => {
  return spur ? generateFunctionSpurs(line, geometry) : generateFunctionLine(line, geometry);
});

export default functionLine;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'function-line': typeof functionLine;
  }
}
